/**
 * Video Popup Module
 * YouTube video popup functionality
 */

export function initVideoPopup() {
  document.querySelectorAll(".nug-video-popup").forEach((video) => {
    video.addEventListener("click", (event) => {
      event.preventDefault();
      openVideoPopup(video);
      return false;
    });
  });
}

function getYoutubeId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);

  if (match && match[2].length == 11) {
    return match[2];
  } else {
    return "error";
  }
}

function openVideoPopup(videoElement) {
  // Create HTML elements
  const divPopupWrap = document.createElement("div");
  const divPopupOverlay = document.createElement("div");
  const divPopupContent = document.createElement("div");
  const divPopupClose = document.createElement("div");
  const divPopupInner = document.createElement("div");

  divPopupWrap.className = "nug-video-popup-wrap";
  divPopupOverlay.className = "nug-popup-overlay";
  divPopupContent.className = "nug-video-popup-content";
  divPopupClose.className = "nug-popup-close";
  divPopupInner.className = "nug-popup-inner";

  document.querySelector("body").prepend(divPopupWrap);
  divPopupWrap.appendChild(divPopupOverlay);
  divPopupWrap.appendChild(divPopupContent);
  divPopupContent.appendChild(divPopupClose);
  divPopupContent.appendChild(divPopupInner);

  const youtubeURL = videoElement.closest("a").getAttribute("href");
  const youtubeID = getYoutubeId(youtubeURL);
  const youtubeIframe = `<iframe
      width="100%"
      height="500"
      src="https://www.youtube-nocookie.com/embed/${youtubeID}?autoplay=1&rel=0"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen>
    </iframe>`;
  divPopupInner.innerHTML = "";

  const div = document.createElement("div");
  div.innerHTML = youtubeIframe;
  divPopupInner.appendChild(div);

  document.body.classList.add("nug-video-popup-opened");

  // Event listeners for closing popup
  const closePopup = () => {
    document.body.classList.remove("nug-video-popup-opened");
    removeVideo(divPopupWrap);
  };

  divPopupOverlay.addEventListener("click", closePopup);
  divPopupClose.addEventListener("click", closePopup);

  // Add ESC key support for closing popup
  const handleEscKey = (e) => {
    if (e.key === "Escape") {
      closePopup();
      document.removeEventListener("keydown", handleEscKey);
    }
  };
  document.addEventListener("keydown", handleEscKey);
}

function removeVideo(element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element);
  }
}
